import { axiosInstance } from '../../utils';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  id: string;
}

const deletePaymentMethod = async ({ id }: Payload): Promise<any> => {
  const res = await axiosInstance.delete(`/api/payments/delete-payment-method/${id}`);
  return res.data;
};

export function useDeletePaymentMethod() {
  return useMutation(deletePaymentMethod, { onSuccess: (data) => data });
}